import React from "react";
import styles from './Footer.module.css';
import {ReactComponent as InstaLogo} from '../../imgs/Instagram_Glyph_White.svg';
import { ReactComponent as PhoneIcon } from '../../imgs/designStrat/phone.svg';
import { ReactComponent as EmailIcon } from '../../imgs/designStrat/email.svg';
import { ReactComponent as Circle } from '../../imgs/Clipping_circle_mask.svg'
import GradientButton from "./GradientButton";
import SLogo from "./SLogo";
import SLogoAnimated from "./SLogoAnimated";
import SLogoNew from "./SLogoNew";
// import { useNavigate } from "react-router-dom";

export default function Footer({navigateToElement}){

    const navigateAboutUs = () => {
        navigateToElement('/home','aboutUsSection');
    }

    const navigateContact = () => {
        window.scrollTo(0,0);
        navigateToElement('/contact','');
    }

    return (
        <footer>
            <div>
                <h2>Use our imagination</h2>
                <h2 className={styles.italicHeader}>Let's talk.</h2>
                <GradientButton navigateContact={navigateContact} />
            </div>
            <div className={styles.footerGrid}>
                <div className={styles.detailsDiv}>
                    <div styles={styles.contactDetails}>
                        <div className={styles.iconTextCon}>
                            <div className={styles.iconCon}>
                                <PhoneIcon />
                            </div>
                            <p>+44 (0) 7813086642</p>
                        </div>
                        <div className={styles.iconTextCon}>
                            <div className={styles.iconCon}>
                                <EmailIcon />
                            </div>
                            <p>info@stratela.co.uk</p>
                        </div>
                    </div>
                    <div className={styles.address}>
                        <div className={styles.headingIconCon}>
                            <div className={styles.headingIcon}>
                                <Circle className={styles.circleDesign}/>
                            </div>
                            <h6 style={{lineHeight: 1}} className={styles.dsHeading}>Design Studio</h6>
                        </div>
                        
                        <p >White Willows, Hook Heath Rd,<br/> Woking, Surrey<br/>GU22 0QF<br/>United Kingdom</p>
                    </div>
                    <div className={styles.address}>
                        <div className={styles.headingIconCon}>
                            <div className={styles.headingIcon}>
                                <Circle className={styles.circleReg}/>
                            </div>
                            <h6 style={{lineHeight: 1}} className={styles.regHeading}>Registered Address</h6>
                        </div>
                        <p className={styles.grey}>124 City Road,<br/>London,<br/>EC1V 2NX<br/>United Kingdom</p>
                    </div>
                </div>
                <div className={styles.sLogoContainer}>
                    <SLogoNew scrollState={1} height={'100%'} width={'100%'} viewportHeight={200} mask={true} logoScale={`1`} background={'1'} maskId={'footerSlogo1'}/>
                </div>
            </div>
            <div className={styles.footerFooter}>
            <img src={require('../../imgs/linkedin-app-white-icon.webp')} />
            © Stratela Ltd 2025 
            </div>
        </footer>
    )
}